import shappyAPI from '@/api/shappy'

export default ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    shappyAPI.getShappyInfo(params, result => {
      if (result.status === 0 && result.data.enable === '1') {
        commit('setShappyInfo', result.data.user.data)
        commit('setShopStatus', true)
      } else {
        commit('setShopStatus', false)
      }
      resolve(result.data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/shappy/actions/getShappyInfo.js